import { put, takeLatest } from "redux-saga/effects";
import { SubPriceActionEnum } from "src/store/reducers/subPrice/types";
import { SubPricesActionCreators } from "src/store/reducers/subPrice/action-creators";
import instance from "../set";

function* fetchGetSubPrice() {
  try {
    const { data } = yield instance.get('priceForSub');
    yield put(SubPricesActionCreators.resultGetSubPrices(data));
  } catch (error) {
    console.log("error :>> ", error);
  }
}
export function* actionWatcherGetSubPrice() {
  yield takeLatest(SubPriceActionEnum.REQUEST_SUBPRICES, fetchGetSubPrice);
}
